module.exports = "<section class=\"app\" ui-view>\n</section>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/index.html
 ** module id = 28
 ** module chunks = 0
 **/